<template>
  <section class="invoice-preview-wrapper">
    <b-row>
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" sm="12" md="3" lg="3" xl="3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <div
              class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
            >
              <!-- Header: Left Content -->
              <div>
                <h2 class="mb-2">Patient Details:</h2>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px">
                      Patient Name:
                    </span>
                    <span style="font-size: 12.5px">
                      {{
                        patientData.first_name +
                        " " +
                        patientData.second_name +
                        " " +
                        patientData.third_name +
                        " " +
                        patientData.forth_name +
                        " " +
                        patientData.nickname +
                        " "
                      }}
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px"
                      >Patient Age:
                    </span>
                    <span style="font-size: 12.5px">
                      {{ patientData.age }} Years Old
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px"
                      >Mother Name:
                    </span>
                    <span style="font-size: 12.5px">
                      {{
                        patientData.first_mother_name +
                        " " +
                        patientData.second_mother_name +
                        " " +
                        patientData.third_mother_name +
                        " " +
                        patientData.forth_mother_name +
                        " "
                      }}
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px"
                      >Main Phone Number:
                    </span>
                    <span style="font-size: 12.5px">
                      {{ patientData.phone }}
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px"
                      >2nd Phone Number:
                    </span>
                    <span style="font-size: 12.5px">
                      {{ patientData.second_phone }}
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px">Address: </span>
                    <span style="font-size: 12.5px">
                      {{ cities[this.patientData.city_id - 1] }},
                      {{ patientData.adderss }}
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px"
                      >National ID:
                    </span>
                    <span style="font-size: 12.5px">
                      {{ patientData.national_id }}
                      <span v-if="patientData.card_type"
                        >, (<span>{{ patientData.card_type }}</span
                        >)</span
                      >
                    </span>
                    <span style="font-size: 12.5px"> </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px">Gender: </span>
                    <span style="font-size: 12.5px">
                      {{ patientData.gender }}
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="auto">
                    <span style="font-weight: bolder; font-size: 12.5px">Referral: </span>
                    <span style="font-size: 12.5px">
                      {{ patientData.patient_referred_from }}
                    </span>
                  </b-col>
                </b-row>
              </div>
            </div>
            <br />
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12" sm="12" md="8" lg="9" xl="9">
        <b-card>
          <h3 class="my-2">
            Cards created for:
            <span>
              {{
                patientData.first_name +
                " " +
                patientData.second_name +
                " " +
                patientData.third_name +
                " " +
                patientData.forth_name +
                " " +
                patientData.nickname +
                " "
              }}
            </span>
          </h3>
          <b-table
            :items="patientCardDetails"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            v-if="!loading"
            empty-text="No Card For This Patient"
          >
            <template #cell(Department)="data">
              <span class="font-weight-bolder text-nowrap">
                {{ departments[data.item.department_id - 1] }}
              </span>
            </template>
          </b-table>
          <template v-if="loading">
            <div>
              <div class="d-flex justify-content-center mb-1">
                <b-spinner label="Loading..." />
              </div>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BFormInput,
  BTable,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";

import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VueQRCodeComponent from "vue-qrcode-component";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    qrcode: VueQRCodeComponent,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    VueHtml2pdf,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  setup() {
    // const patientData = ref(null)
  },

  data() {
    return {
      tableColumns: [
        { key: "Department", sortable: true },
        { key: "created_at", label: "date", sortable: true },
        // { key: "Actions" },
      ],
      patientData: [],
      todayDate: "",
      assignForm: {
        department_id: "",
        patient_id: "",
        barcode: "",
      },
      EditForm: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        nickname: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        phone: "",
        second_phone: "",
        age: "",
        adderss: "",
        _method: "PUT",
      },
      errorForm: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        nickname: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        card_type: "",
        phone: "",
        second_phone: "",
        age: "",
        adderss: "",
        birthday: "",
        city_id: "",
      },
      // this will be updated after modify the departments list in the api
      departments: [
        "Reciption", // 1
        "Managment",
        "Clinic",
        "Emergency",
        "Laboratory",
        "Pharmacy",
        "Daily Care",
        "Consultant",
        "",
        "",
        "Chemotherapy", // 11 --> TODO: should be reorder to 9 from backend
      ],
      cities: [],
      city: "Baghdad",
      loading: true,
      AssignLoading: true,
      patientsAssignment: [],
      assignButton: true,
      patientAssignId: "",
      selected: "",
      option: [],
      params: {
        form: {},
        path: "",
      },
      patientCardDetails: [],
      patientDataID: "",
      buttonLoading: true,
    };
  },

  mounted() {
    this.getPatientInfo();
  },
  methods: {
    async getPatientInfo() {
      await this.getPatient(`/patient/${router.currentRoute.params.id}`);
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientData = this.all_data;
      this.getPatientCard();
    },
    async getPatientCard() {
      await this.getPatient(`patient/card?filter[patient_id]=${this.patientData.uuid}`);
      if (this.all_data.data) {
        this.patientCardDetails = this.all_data.data;
        this.buttonLoading = true;
      }
      if (this.all_data.data.length == 0) {
        this.patientCardDetails = [];
        this.buttonLoading = false;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 576px) {
  .modalDiv {
    height: 34rem;
  }
}

.qrcodeStyle {
  width: 10rem;
  margin: 0 auto;
  padding-top: 2rem;
}

.font-modify {
  letter-spacing: normal !important;
}

.modalPrint {
  margin-top: 1rem;
  margin-left: 3rem;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
